module.exports = __webpack_public_path__ + "img/thumb-mobility.e7a718e1.jpg";